import { useCallback, useEffect, useMemo, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import DataTable from 'react-data-table-component'
import { create, differenceBy, isEmpty } from 'lodash';
import { Box, Button, MenuItem, Select, Stack, Typography } from '@mui/material';
import { toggleNoti, toggleError } from 'config/slice/message'
import NoDataComponent from './NoDataComponent';
import SearchComponent from './SearchComponent';
import TableModals from './TableModals';
import { downloadCSV } from 'utils/exportCSV';
import { useDelEnquiryMutation, useDelUserMutation, useGetUserListMutation, useListEnquiryMutation, useSendRecpMutation, useSendReplyMutation, useUpdateUserMutation } from 'config/api/waV1_user';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import { Textarea } from '@mui/joy';
import { useTranslation } from 'react-i18next';
import { KEY_COL_LABEL_USER_EMAIL, KEY_COL_LABEL_USER_ENQUIRY_TYPE, KEY_COL_LABEL_USER_NAME, KEY_COL_LABEL_USER_PHONE, KEY_ERROR_DELETE_FAILED, KEY_ERROR_REPLY_FAILED, KEY_ERROR_UPDATE_FAILED, KEY_LABEL_DELETE, KEY_LABEL_EXPORT_AS, KEY_LABEL_EXPORT_AS_CSV, KEY_LABEL_EXPORT_AS_PDF, KEY_LABEL_EXPORT_FILE_FORMAT, KEY_LABEL_FORM_PIG_MESSAGE, KEY_LABEL_FORM_PIG_PLURAL, KEY_LABEL_FORM_PIG_ROWS_PER_PAGE, KEY_LABEL_FORM_PIG_SELECT_ALL, KEY_LABEL_FORM_PIG_SINGULAR, KEY_LABEL_FORM_TABLE_TITLE, KEY_LABEL_REPLY, KEY_LABEL_REPLY_PHD, KEY_NOTI_DELETE_SUCC, KEY_NOTI_MSG_DELETE, KEY_NOTI_REPLY_SUCC, KEY_NOTI_UPDATE_SUCC, MODULE_PREVIEW_ROUTER_FORM, MODULE_REPLY_SELECTION } from 'config/const/locale';
import { sug_data } from 'config/dataToRender/suggestion';

const reply_select = sug_data

// table data
const tableData = []

function createRow(id, name, phone, email, enquiry_type, extra) {
    return { id, name, phone, email, enquiry_type, extra }
}

/**
 * react-data-table-component for ref: https://www.npmjs.com/package/react-data-table-component/v/6.11.8#header-context-menu-when-using-selectable-rows
 * export pdf for ref: jspdf(http://raw.githack.com/MrRio/jsPDF/master/docs/index.html) and jspdf-autotable(https://github.com/simonbengtsson/jsPDF-AutoTable)
 * @Todo i18n
 */
export default function CMSTableWithEnquiry() {

    const { t } = useTranslation([MODULE_PREVIEW_ROUTER_FORM, MODULE_REPLY_SELECTION])

    // columns definition
    const columns = [
        {
            id: 'id',
            name: '#',
            selector: row => row.id,
            sortable: true,
            width: '64px',
        },
        {
            id: 'name',
            name: t(KEY_COL_LABEL_USER_NAME),
            selector: row => row.name,
        },
        {
            id: 'phone',
            name: t(KEY_COL_LABEL_USER_PHONE),
            selector: row => row.phone,
        },
        {
            id: 'email',
            name: t(KEY_COL_LABEL_USER_EMAIL),
            selector: row => row.email,
            grow: 2
        },
        {
            id: 'enquiry_type',
            name: t(KEY_COL_LABEL_USER_ENQUIRY_TYPE),
            selector: row => row.enquiry_type,
            grow: 3
        }
    ];
    const { lng } = useSelector(state => state.global)
    const [selectedRows, setSelectedRows] = useState([]); // save the selected row
    const [toggleCleared, setToggleCleared] = useState(false); // indicate whether hiding the context or not
    const [isEditTableData, setIsEditTableData] = useState(false) // indicate the row table's state: editable or uneditable
    const [allRowData, setAllRowData] = useState(tableData); // save the all table data
    let rowData = {} // save the data waiting to change

    const [expandedRows, setExpandedRows] = useState({})
    const [editRowById, setEditRowById] = useState(0)
    const reply = useRef('')

    const [filterText, setFilterText] = useState(''); // keyword to search
    const [filterType, setFilterType] = useState(columns[0]?.id) // type to search with keyword
    // const [resetPaginationToggle, setResetPaginationToggle] = useState(false);

    const [getUserListFn] = useGetUserListMutation()
    const [updateUserFn] = useUpdateUserMutation()
    const [delUserFn] = useDelUserMutation()
    const [listEnquiriesFn] = useListEnquiryMutation()
    const [delEnquiriesFn] = useDelEnquiryMutation()
    const [sendReplyFn] = useSendReplyMutation()
    const dispatch = useDispatch()


    // filter results when conditions meet
    let filteredItems =
        allRowData.filter(
            item => item[filterType] && String(item[filterType]).toLowerCase().includes(filterText.toLowerCase())
        );

    const handleReply = (eid, rev) => () => {
        sendReplyFn({
            "enquiry_id": eid,
            "receiver": rev,
            "content": reply.current
        })
            .then(res => {
                if (res.data?.data?.enquiry) {
                    dispatch(toggleNoti({
                        indicator: true,
                        msg: t(KEY_NOTI_REPLY_SUCC)
                    }))
                    window.location.reload()
                } else {
                    dispatch(toggleError({
                        indicator: true,
                        msg: t(KEY_ERROR_REPLY_FAILED)
                    }))
                }
            })
            .catch(reason => {
                dispatch(toggleError({
                    indicator: true,
                    msg: t(KEY_ERROR_REPLY_FAILED)
                }))
            })
    }

    // save row table's input value
    const iptOnChangeHandler =
        (id, iptType) => (event) => {
            rowData = {
                id,
                type: iptType,
                value: event.target.value
            }
        }

    // Table's subHeader
    const subHeaderComponentMemo = useMemo(() => (
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: "100%" }}>
            <div style={{ display: 'flex' }}>
                {/* <Button type="button">create</Button> */}
                {/* <TableModals columns={columns} dataSetter={setAllRowData} /> */}

                {/* <div style={{ paddingLeft: 16, marginLeft: 16, borderLeft: '1px solid black' }}> */}
                <div >
                    <Select
                        variant='filled'
                        value={1}
                        disableUnderline
                        sx={{
                            '&>div': {
                                p: 1.5
                            }
                        }}
                    >
                        <MenuItem value={1} disabled hidden >{t(KEY_LABEL_EXPORT_AS)}</MenuItem>
                        <MenuItem onClick={() => downloadCSV(isEmpty(selectedRows) ? allRowData : selectedRows)}>{t(KEY_LABEL_EXPORT_AS_CSV)}</MenuItem>
                        <MenuItem onClick={() => exportPdf(selectedRows, allRowData)}>{t(KEY_LABEL_EXPORT_AS_PDF)}</MenuItem>
                        {/* <MenuItem>SQL</MenuItem> */}
                        {/* <MenuItem>JSON</MenuItem> */}
                        {/* <MenuItem>XML</MenuItem> */}
                        {/* <MenuItem>MS-Excel</MenuItem> */}
                    </Select>
                </div>
            </div >
            {/* <input placeholder='type keyword to search' onChange={e => setFilterText(e.target.value)} onClear={handleClear} filterText={filterText} /> */}
            < SearchComponent columns={columns} Kword={filterText} saveKeyword={setFilterText} KType={filterType} ChangeKType={setFilterType} />
        </div >
    ), [
        filterText,
        filterType,
        selectedRows,
        allRowData,
        lng
        // resetPaginationToggle
    ]);

    //save the selected rows data to state
    const handleRowSelected = useCallback(state => {
        setSelectedRows(state.selectedRows);
    }, []);

    useEffect(() => {
        listEnquiriesFn()
            .then(
                res => {
                    setAllRowData(
                        new Array(...(res?.data?.data?.enquiries?.data))
                            .map(
                                i => createRow(
                                    i.id,
                                    i.name,
                                    i.phone,
                                    i.email,
                                    // i.enquiry_type,
                                    t(reply_select.filter(it => it.value === i.enquiry_type)[0]?.label, { ns: MODULE_REPLY_SELECTION }),
                                    i
                                )
                            )
                    )
                }
            )
            .catch(
                reason => console.log(reason)
            )

    }, [lng])

    // context component includes delete action
    const contextActions = useMemo(() => {
        const handleDelete = () => {

            if (window.confirm(t(KEY_NOTI_MSG_DELETE))) {
                selectedRows.map(
                    i => delEnquiriesFn(i.id)
                        .then(res => {
                            if (res.data?.data) {
                                dispatch(toggleNoti({
                                    indicator: true,
                                    msg: t(KEY_NOTI_DELETE_SUCC)
                                }))
                                window.location.reload()
                            } else {
                                dispatch(toggleError({
                                    indicator: true,
                                    msg: t(KEY_ERROR_DELETE_FAILED)
                                }))
                            }
                        })
                        .catch(reason => {
                            dispatch(toggleError({
                                indicator: true,
                                msg: t(KEY_ERROR_DELETE_FAILED)
                            }))
                        })
                        .finally(() => {
                            setToggleCleared(!toggleCleared);
                        })
                )
                // setAllRowData(differenceBy(allRowData, selectedRows, 'id'));
            }
        };

        return (
            <Button
                key="delete"
                variant="danger"
                onClick={handleDelete}
                style={{ backgroundColor: 'red', color: 'white', fontSize: 14, fontWeight: 700 }} >
                {t(KEY_LABEL_DELETE)}
            </Button >
        );
    }, [allRowData, selectedRows, toggleCleared]);

    // save changed row data to state
    const confirmChange = useCallback(() => {
        updateUserFn(rowData)
            .then(
                res => {
                    if (res.data?.data) {
                        dispatch(toggleNoti({
                            indicator: true,
                            msg: t(KEY_NOTI_UPDATE_SUCC)
                        }))
                        window.location.reload()
                    } else {
                        dispatch(toggleError({
                            indicator: true,
                            msg: t(KEY_ERROR_UPDATE_FAILED)
                        }))
                    }
                }
            )
            .catch(
                reason => dispatch(toggleError({
                    indicator: true,
                    msg: t(KEY_ERROR_UPDATE_FAILED)
                }))
            )
            .finally(() => {
                setIsEditTableData(false)
            })
        // if (isEmpty(rowData) && isEmpty(rowData?.id)) return setIsEditTableData(false)
        // // setAllRowData(pre => pre.map(i => (i.id === rowData.id) ? set(i, rowData.type, rowData.value) : i))
        // setAllRowData(pre => pre.map(i => (i.id === rowData.id) ? { ...i, [rowData?.type]: rowData?.value } : i))
        // setIsEditTableData(false)
    }, [rowData, allRowData])

    /**
     * expanded component ?? bad performance ??
     * @param {Object} data the expanded row data
     */
    const ExpandedComponent = ({ data }) => {

        return (
            <Stack display={'flex'} flexDirection='row' flexWrap={'wrap'}>
                <Card variant="outlined" sx={{ minWidth: 275, maxWidth: 400, m: 2 }}>
                    <CardContent>
                        <Typography sx={{ fontSize: 14 }} color="text.secondary" gutterBottom>
                            {data.email}, {data.phone}
                        </Typography>
                        <Typography variant="h5" component="div">
                            {data.name}
                        </Typography>
                        {/* <Typography sx={{ mb: 1.5 }} color="text.secondary">
                            正文
                        </Typography> */}
                        <Typography variant="body">
                            ‘{data.extra.content}’
                        </Typography>
                    </CardContent>
                </Card>
                {
                    data?.extra?.replies?.map(
                        i => (
                            <Card variant="outlined" sx={{ minWidth: 275, m: 2, backgroundColor: 'ButtonFace' }}>
                                <CardContent>
                                    <Typography sx={{ fontSize: 14 }} color="text.secondary" gutterBottom>
                                        reply -- {i.email}, {data.phone}
                                    </Typography>
                                    <Typography variant="h5" component="div">
                                        {i.name}
                                    </Typography>
                                    {/* <Typography sx={{ mb: 1.5 }} color="text.secondary">
                            正文
                        </Typography> */}
                                    <Typography variant="body">
                                        ‘{i.content}’
                                    </Typography>
                                </CardContent>
                            </Card>
                        )
                    )
                }
                <Card variant="outlined" sx={{ minWidth: 275, m: 2 }}>
                    <CardContent>
                        <Textarea
                            placeholder={t(KEY_LABEL_REPLY_PHD)}
                            minRows={8}
                            onChange={(e) => {
                                reply.current = e.target.value
                            }}
                        />
                    </CardContent>
                    <CardActions>
                        <Button variant='contained' size="small" onClick={handleReply(data?.id, data?.email)}>{t(KEY_LABEL_REPLY)}</Button>
                    </CardActions>
                </Card>
            </Stack>
        )
    }

    // const actionsMemo = useMemo(() => <Export onExport={() => downloadCSV(data)} />, []);


    const handleChange = ({ allSelected, selectedCount, selectedRows }) => {
        // You can set state or dispatch with something like Redux so we can use the retrieved data
        console.log('Selected Rows: ', selectedRows);
    };

    // export pdf func waiting to optimize
    const exportPdf = useCallback(() => {
        import('jspdf').then((jsPDF) => {
            import('jspdf-autotable').then(() => {
                const doc = new jsPDF.default(0, 0);

                const exportColumns = columns.map((col) => ({ title: col.name, dataKey: col.id }));

                doc.autoTable(exportColumns, isEmpty(selectedRows) ? allRowData : selectedRows);
                doc.save(t(KEY_LABEL_EXPORT_FILE_FORMAT));
            });
        });
    }, [columns, selectedRows, allRowData])


    return (
        <DataTable
            title={t(KEY_LABEL_FORM_TABLE_TITLE)}

            subHeader
            subHeaderComponent={subHeaderComponentMemo}

            columns={columns}
            data={filteredItems}

            // selected row
            selectableRows
            selectableRowsHighlight
            selectableRowsVisibleOnly
            onSelectedRowsChange={handleRowSelected}
            clearSelectedRows={toggleCleared}

            // expanded row
            expandableRows
            expandableRowsComponent={ExpandedComponent}
            expandOnRowDoubleClicked
            expandableRowExpanded={(row) => expandedRows?.id === row.id ? true : false}
            onRowExpandToggled={(toggleState, row) => {
                // console.log(toggleState, row)
                if (toggleState) setExpandedRows(row)
            }}

            // sorting setting
            defaultSortFieldId={'id'}
            defaultSortAsc

            // context setting
            // contextComponent={<div>hello</div>}
            contextActions={contextActions}
            contextMessage={{
                singular: t(KEY_LABEL_FORM_PIG_SINGULAR),
                plural: t(KEY_LABEL_FORM_PIG_PLURAL),
                message: t(KEY_LABEL_FORM_PIG_MESSAGE)
            }}

            pagination
            paginationRowsPerPageOptions={[10, 20, 50, 100]}
            paginationComponentOptions={{
                rowsPerPageText: t(KEY_LABEL_FORM_PIG_ROWS_PER_PAGE),
                rangeSeparatorText: '/',
                noRowsPerPage: false,
                selectAllRowsItem: true,
                selectAllRowsItemText: t(KEY_LABEL_FORM_PIG_SELECT_ALL)
            }}

            noDataComponent={<NoDataComponent />}

            highlightOnHover
            striped
            responsive


        />
    )
}
